export const PROJECT_TYPE = {
    ENTITY: "1",
    GROUP_CODE: "2",
    DATABASE: "3",
    ENVIRONMENT: "4",
    DATA_SOURCE: "5",
    REPORTING: "6",
    SYSTEM: "7",
}

export const DATA_SOURCE_TYPE = {
    FILE_REPOSITORY: "1",
    MSSQL: "2",
    SHAREPOINT: "3"
}